/* eslint-disable import/no-cycle */
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core'

import { ICellRendererAngularComp } from 'ag-grid-angular'
import { ICellRendererParams } from 'ag-grid-community'

import { FlxStyleModule } from '@flowx/angular-theme'
import { CollectionPrototypeInstanceMeta, TableCellTemplateConfig } from '@flowx/core-sdk'

import { FlxTreeNodeComponent } from '../../../renderer/tree-node/tree-node.component'

type CellRendererParams = ICellRendererParams & { config: TableCellTemplateConfig }

@Component({
  selector: 'flx-table-cell',
  imports: [FlxTreeNodeComponent, FlxStyleModule],
  templateUrl: './flx-table-cell.component.html',
  styleUrl: './flx-table-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxTableCellComponent implements ICellRendererAngularComp {
  rowId = signal<string>(null)
  templateConfig = signal<TableCellTemplateConfig>(null)
  prototypeInstanceMeta = signal<CollectionPrototypeInstanceMeta[]>([])

  cellConfig = computed<TableCellTemplateConfig>(() => ({
    ...this.templateConfig(),
    flowxUuid: `${this.templateConfig().flowxUuid}-${this.rowId()}`,
  }))

  displayOptions = computed(() => this.templateConfig().displayOptions)
  flowxProps = computed(() => this.displayOptions().flowxProps)

  agInit(params: CellRendererParams): void {
    this.#initProperties(params)
  }

  refresh(params: CellRendererParams): boolean {
    this.#initProperties(params)
    return true
  }

  #initProperties(params: CellRendererParams): void {
    this.templateConfig.set(params.config)
    this.prototypeInstanceMeta.set(params.data[params.colDef.field])
    this.rowId.set(params.node.id)
  }
}
